var _defineProperty = require("/home/meeexy/Documents/dev/dbooks/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/home/meeexy/Documents/dev/dbooks/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/meeexy/Documents/dev/dbooks/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/meeexy/Documents/dev/dbooks/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/home/meeexy/Documents/dev/dbooks/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/meeexy/Documents/dev/dbooks/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/meeexy/Documents/dev/dbooks/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("prop-types"), require("@drizzle/react-plugin")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@drizzle/react-plugin"], e) : "object" == typeof exports ? exports["@drizzle/react-components"] = e(require("react"), require("prop-types"), require("@drizzle/react-plugin")) : t["@drizzle/react-components"] = e(t.react, t["prop-types"], t["@drizzle/react-plugin"]);
}("undefined" != typeof self ? self : this, function (t, e, s) {
  return function (t) {
    var e = {};

    function s(r) {
      if (e[r]) return e[r].exports;
      var n = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(n.exports, n, n.exports, s), n.l = !0, n.exports;
    }

    return s.m = t, s.c = e, s.d = function (t, e, r) {
      s.o(t, e) || Object.defineProperty(t, e, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, s.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return s.d(e, "a", e), e;
    }, s.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, s.p = "", s(s.s = 3);
  }([function (e, s) {
    e.exports = t;
  }, function (t, s) {
    t.exports = e;
  }, function (t, e) {
    t.exports = s;
  }, function (t, e, s) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), s.d(e, "newContextComponents", function () {
      return u;
    });
    var r = s(4),
        n = s(5),
        a = s(6),
        i = s(7),
        o = s(8),
        c = s(9),
        p = s(10);
    s.d(e, "AccountData", function () {
      return r.a;
    }), s.d(e, "ContractData", function () {
      return n.a;
    }), s.d(e, "ContractForm", function () {
      return a.a;
    }), s.d(e, "LoadingContainer", function () {
      return i.a;
    });
    var u = {
      AccountData: o.a,
      ContractData: c.a,
      ContractForm: p.a
    };
  }, function (t, e, s) {
    "use strict";

    var r = s(2),
        n = (s.n(r), s(0)),
        a = s.n(n),
        i = s(1),
        o = s.n(i);

    var c = /*#__PURE__*/function (_n$Component) {
      _inherits(c, _n$Component);

      var _super = _createSuper(c);

      function c(t) {
        var _this;

        _classCallCheck(this, c);

        _this = _super.call(this, t), _this.precisionRound = _this.precisionRound.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(c, [{
        key: "precisionRound",
        value: function precisionRound(t, e) {
          var s = Math.pow(10, e);
          return Math.round(t * s) / s;
        }
      }, {
        key: "render",
        value: function render() {
          if (0 === Object.keys(this.props.accounts).length) return a.a.createElement("span", null, "Initializing...");
          var t = this.props.accounts[this.props.accountIndex];
          var e = this.props.accountBalances[t];
          var s = this.props.units ? this.props.units.charAt(0).toUpperCase() + this.props.units.slice(1) : "Wei";
          return this.props.units && void 0 !== e && (e = this.context.drizzle.web3.utils.fromWei(e, this.props.units)), this.props.precision && (e = this.precisionRound(e, this.props.precision)), this.props.render ? this.props.render({
            address: t,
            balance: e,
            units: s
          }) : a.a.createElement("div", null, a.a.createElement("h4", null, t), a.a.createElement("p", null, e, " ", s));
        }
      }]);

      return c;
    }(n.Component);

    c.contextTypes = {
      drizzle: o.a.object
    }, c.propTypes = {
      accounts: o.a.objectOf(o.a.string),
      accountBalances: o.a.objectOf(o.a.string),
      accountIndex: o.a.number.isRequired,
      units: o.a.string,
      precision: o.a.number,
      render: o.a.func
    };
    e.a = Object(r.drizzleConnect)(c, function (t) {
      return {
        accounts: t.accounts,
        accountBalances: t.accountBalances
      };
    });
  }, function (t, e, s) {
    "use strict";

    var r = s(2),
        n = (s.n(r), s(0)),
        a = s.n(n),
        i = s(1),
        o = s.n(i);

    var c = /*#__PURE__*/function (_n$Component2) {
      _inherits(c, _n$Component2);

      var _super2 = _createSuper(c);

      function c(t, e) {
        var _this2$contracts$_thi;

        var _this2;

        _classCallCheck(this, c);

        _this2 = _super2.call(this, t);
        var s = _this2.props.methodArgs ? _this2.props.methodArgs : [];
        _this2.contracts = e.drizzle.contracts, _this2.state = {
          dataKey: (_this2$contracts$_thi = _this2.contracts[_this2.props.contract].methods[_this2.props.method]).cacheCall.apply(_this2$contracts$_thi, _toConsumableArray(s))
        };
        return _this2;
      }

      _createClass(c, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(t) {
          var _this$contracts$t$con;

          var _this$props = this.props,
              e = _this$props.methodArgs,
              s = _this$props.contract,
              r = _this$props.method,
              n = s !== t.contract,
              a = r !== t.method,
              i = JSON.stringify(e) !== JSON.stringify(t.methodArgs);
          (n || a || i) && this.setState({
            dataKey: (_this$contracts$t$con = this.contracts[t.contract].methods[t.method]).cacheCall.apply(_this$contracts$t$con, _toConsumableArray(t.methodArgs))
          });
        }
      }, {
        key: "render",
        value: function render() {
          if (!this.props.contracts[this.props.contract].initialized) return a.a.createElement("span", null, "Initializing...");
          if (!(this.state.dataKey in this.props.contracts[this.props.contract][this.props.method])) return a.a.createElement("span", null, "Fetching...");
          var t = this.props.contracts[this.props.contract].synced ? "" : " 🔄";
          this.props.hideIndicator && (t = "");
          var e = this.props.contracts[this.props.contract][this.props.method][this.state.dataKey].value;
          if (this.props.toUtf8 && (e = this.context.drizzle.web3.utils.hexToUtf8(e)), this.props.toAscii && (e = this.context.drizzle.web3.utils.hexToAscii(e)), this.props.render) return this.props.render(e);

          if (Array.isArray(e)) {
            var _s = e.map(function (e, s) {
              return a.a.createElement("li", {
                key: s
              }, "".concat(e), t);
            });

            return a.a.createElement("ul", null, _s);
          }

          if ("object" == typeof e) {
            var s = 0;
            var _r = [];
            return Object.keys(e).forEach(function (n) {
              s != n && _r.push(a.a.createElement("li", {
                key: s
              }, a.a.createElement("strong", null, n), t, a.a.createElement("br", null), "".concat(e[n]))), s++;
            }), a.a.createElement("ul", null, _r);
          }

          return a.a.createElement("span", null, "".concat(e), t);
        }
      }]);

      return c;
    }(n.Component);

    c.contextTypes = {
      drizzle: o.a.object
    }, c.propTypes = {
      contracts: o.a.object.isRequired,
      contract: o.a.string.isRequired,
      method: o.a.string.isRequired,
      methodArgs: o.a.array,
      hideIndicator: o.a.bool,
      toUtf8: o.a.bool,
      toAscii: o.a.bool,
      render: o.a.func
    };
    e.a = Object(r.drizzleConnect)(c, function (t) {
      return {
        contracts: t.contracts
      };
    });
  }, function (t, e, s) {
    "use strict";

    var r = s(2),
        n = (s.n(r), s(0)),
        a = s.n(n),
        i = s(1),
        o = s.n(i);

    var c = function c(t) {
      switch (!0) {
        case /^uint/.test(t):
          return "number";

        case /^string/.test(t) || /^bytes/.test(t):
          return "text";

        case /^bool/.test(t):
          return "checkbox";

        default:
          return "text";
      }
    };

    var p = /*#__PURE__*/function (_n$Component3) {
      _inherits(p, _n$Component3);

      var _super3 = _createSuper(p);

      function p(t, e) {
        var _this3;

        _classCallCheck(this, p);

        _this3 = _super3.call(this, t), _this3.handleInputChange = _this3.handleInputChange.bind(_assertThisInitialized(_this3)), _this3.handleSubmit = _this3.handleSubmit.bind(_assertThisInitialized(_this3)), _this3.contracts = e.drizzle.contracts, _this3.utils = e.drizzle.web3.utils;
        var s = _this3.contracts[_this3.props.contract].abi;
        _this3.inputs = [];

        for (var r = {}, n = 0; n < s.length; n++) {
          if (s[n].name === _this3.props.method) {
            _this3.inputs = s[n].inputs;

            for (var a = 0; a < _this3.inputs.length; a++) {
              r[_this3.inputs[a].name] = "";
            }

            break;
          }
        }

        _this3.state = r;
        return _this3;
      }

      _createClass(p, [{
        key: "handleSubmit",
        value: function handleSubmit(t) {
          var _this4 = this,
              _this$contracts$this$,
              _this$contracts$this$2;

          t.preventDefault();
          var e = this.inputs.map(function (t) {
            return "bytes32" === t.type ? _this4.utils.toHex(_this4.state[t.name]) : _this4.state[t.name];
          });
          return this.props.sendArgs ? (_this$contracts$this$ = this.contracts[this.props.contract].methods[this.props.method]).cacheSend.apply(_this$contracts$this$, _toConsumableArray(e).concat([this.props.sendArgs])) : (_this$contracts$this$2 = this.contracts[this.props.contract].methods[this.props.method]).cacheSend.apply(_this$contracts$this$2, _toConsumableArray(e));
        }
      }, {
        key: "handleInputChange",
        value: function handleInputChange(t) {
          var e = "checkbox" === t.target.type ? t.target.checked : t.target.value;
          this.setState(_defineProperty({}, t.target.name, e));
        }
      }, {
        key: "render",
        value: function render() {
          var _this5 = this;

          return this.props.render ? this.props.render({
            inputs: this.inputs,
            inputTypes: this.inputs.map(function (t) {
              return c(t.type);
            }),
            state: this.state,
            handleInputChange: this.handleInputChange,
            handleSubmit: this.handleSubmit
          }) : a.a.createElement("form", {
            className: "pure-form pure-form-stacked",
            onSubmit: this.handleSubmit
          }, this.inputs.map(function (t, e) {
            var s = c(t.type),
                r = _this5.props.labels ? _this5.props.labels[e] : t.name;
            return a.a.createElement("input", {
              key: t.name,
              type: s,
              name: t.name,
              value: _this5.state[t.name],
              placeholder: r,
              onChange: _this5.handleInputChange
            });
          }), a.a.createElement("button", {
            key: "submit",
            className: "pure-button",
            type: "button",
            onClick: this.handleSubmit
          }, "Submit"));
        }
      }]);

      return p;
    }(n.Component);

    p.contextTypes = {
      drizzle: o.a.object
    }, p.propTypes = {
      contract: o.a.string.isRequired,
      method: o.a.string.isRequired,
      sendArgs: o.a.object,
      labels: o.a.arrayOf(o.a.string),
      render: o.a.func
    };
    e.a = Object(r.drizzleConnect)(p, function (t) {
      return {
        contracts: t.contracts
      };
    });
  }, function (t, e, s) {
    "use strict";

    var r = s(2),
        n = (s.n(r), s(0)),
        a = s.n(n),
        i = s(1),
        o = s.n(i);

    var c = /*#__PURE__*/function (_n$Component4) {
      _inherits(c, _n$Component4);

      var _super4 = _createSuper(c);

      function c() {
        _classCallCheck(this, c);

        return _super4.apply(this, arguments);
      }

      _createClass(c, [{
        key: "render",
        value: function render() {
          return "failed" === this.props.web3.status ? this.props.errorComp ? this.props.errorComp : a.a.createElement("main", {
            className: "container loading-screen"
          }, a.a.createElement("div", {
            className: "pure-g"
          }, a.a.createElement("div", {
            className: "pure-u-1-1"
          }, a.a.createElement("h1", null, "⚠️"), a.a.createElement("p", null, "This browser has no connection to the Ethereum network. Please use the Chrome/FireFox extension MetaMask, or dedicated Ethereum browsers Mist or Parity.")))) : "initialized" === this.props.web3.status && 0 === Object.keys(this.props.accounts).length ? a.a.createElement("main", {
            className: "container loading-screen"
          }, a.a.createElement("div", {
            className: "pure-g"
          }, a.a.createElement("div", {
            className: "pure-u-1-1"
          }, a.a.createElement("h1", null, "🦊"), a.a.createElement("p", null, a.a.createElement("strong", null, "We can't find any Ethereum accounts!"), " Please check and make sure Metamask or your browser are pointed at the correct network and your account is unlocked.")))) : this.props.drizzleStatus.initialized ? n.Children.only(this.props.children) : this.props.loadingComp ? this.props.loadingComp : a.a.createElement("main", {
            className: "container loading-screen"
          }, a.a.createElement("div", {
            className: "pure-g"
          }, a.a.createElement("div", {
            className: "pure-u-1-1"
          }, a.a.createElement("h1", null, "⚙️"), a.a.createElement("p", null, "Loading dapp..."))));
        }
      }]);

      return c;
    }(n.Component);

    c.contextTypes = {
      drizzle: o.a.object
    }, c.propTypes = {
      children: o.a.node,
      accounts: o.a.object.isRequired,
      drizzleStatus: o.a.object.isRequired,
      web3: o.a.object.isRequired,
      loadingComp: o.a.node,
      errorComp: o.a.node
    };
    e.a = Object(r.drizzleConnect)(c, function (t) {
      return {
        accounts: t.accounts,
        drizzleStatus: t.drizzleStatus,
        web3: t.web3
      };
    });
  }, function (t, e, s) {
    "use strict";

    var r = s(0),
        n = s.n(r),
        a = s(1),
        i = s.n(a);

    var o = /*#__PURE__*/function (_r$Component) {
      _inherits(o, _r$Component);

      var _super5 = _createSuper(o);

      function o(t) {
        var _this6;

        _classCallCheck(this, o);

        _this6 = _super5.call(this, t), _this6.precisionRound = _this6.precisionRound.bind(_assertThisInitialized(_this6));
        return _this6;
      }

      _createClass(o, [{
        key: "precisionRound",
        value: function precisionRound(t, e) {
          var s = Math.pow(10, e);
          return Math.round(t * s) / s;
        }
      }, {
        key: "render",
        value: function render() {
          if (0 === Object.keys(this.props.drizzleState.accounts).length) return n.a.createElement("span", null, "Initializing...");
          var t = this.props.drizzleState.accounts[this.props.accountIndex];
          var e = this.props.drizzleState.accountBalances[t];
          var s = this.props.units ? this.props.units.charAt(0).toUpperCase() + this.props.units.slice(1) : "Wei";
          return this.props.units && void 0 !== e && (e = this.props.drizzle.web3.utils.fromWei(e, this.props.units)), this.props.precision && (e = this.precisionRound(e, this.props.precision)), this.props.render ? this.props.render({
            address: t,
            balance: e,
            units: s
          }) : n.a.createElement("div", null, n.a.createElement("h4", null, t), n.a.createElement("p", null, e, " ", s));
        }
      }]);

      return o;
    }(r.Component);

    o.propTypes = {
      drizzle: i.a.object.isRequired,
      drizzleState: i.a.object.isRequired,
      accountIndex: i.a.number.isRequired,
      units: i.a.string,
      precision: i.a.number,
      render: i.a.func
    }, e.a = o;
  }, function (t, e, s) {
    "use strict";

    var r = s(0),
        n = s.n(r),
        a = s(1),
        i = s.n(a);

    var o = /*#__PURE__*/function (_r$Component2) {
      _inherits(o, _r$Component2);

      var _super6 = _createSuper(o);

      function o(t) {
        var _this7$contracts$_thi;

        var _this7;

        _classCallCheck(this, o);

        _this7 = _super6.call(this, t);
        var e = _this7.props.methodArgs ? _this7.props.methodArgs : [];
        _this7.contracts = t.drizzle.contracts, _this7.state = {
          dataKey: (_this7$contracts$_thi = _this7.contracts[_this7.props.contract].methods[_this7.props.method]).cacheCall.apply(_this7$contracts$_thi, _toConsumableArray(e))
        };
        return _this7;
      }

      _createClass(o, [{
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(t) {
          var _this$contracts$t$con2;

          var _this$props2 = this.props,
              e = _this$props2.methodArgs,
              s = _this$props2.contract,
              r = _this$props2.method,
              n = s !== t.contract,
              a = r !== t.method,
              i = JSON.stringify(e) !== JSON.stringify(t.methodArgs);
          (n || a || i) && this.setState({
            dataKey: (_this$contracts$t$con2 = this.contracts[t.contract].methods[t.method]).cacheCall.apply(_this$contracts$t$con2, _toConsumableArray(t.methodArgs))
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props3 = this.props,
              t = _this$props3.drizzle,
              e = _this$props3.drizzleState;
          if (!e.contracts[this.props.contract].initialized) return n.a.createElement("span", null, "Initializing...");
          if (!(this.state.dataKey in e.contracts[this.props.contract][this.props.method])) return n.a.createElement("span", null, "Fetching...");
          var s = e.contracts[this.props.contract].synced ? "" : " 🔄";
          this.props.hideIndicator && (s = "");
          var r = e.contracts[this.props.contract][this.props.method][this.state.dataKey].value;
          if (this.props.toUtf8 && (r = t.web3.utils.hexToUtf8(r)), this.props.toAscii && (r = t.web3.utils.hexToAscii(r)), this.props.render) return this.props.render(r);

          if (Array.isArray(r)) {
            var _t = r.map(function (t, e) {
              return n.a.createElement("li", {
                key: e
              }, "".concat(t), s);
            });

            return n.a.createElement("ul", null, _t);
          }

          if ("object" == typeof r) {
            var a = 0;
            var _t2 = [];
            return Object.keys(r).forEach(function (e) {
              a != e && _t2.push(n.a.createElement("li", {
                key: a
              }, n.a.createElement("strong", null, e), s, n.a.createElement("br", null), "".concat(r[e]))), a++;
            }), n.a.createElement("ul", null, _t2);
          }

          return n.a.createElement("span", null, "".concat(r), s);
        }
      }]);

      return o;
    }(r.Component);

    o.propTypes = {
      drizzle: i.a.object.isRequired,
      drizzleState: i.a.object.isRequired,
      contract: i.a.string.isRequired,
      method: i.a.string.isRequired,
      methodArgs: i.a.array,
      hideIndicator: i.a.bool,
      toUtf8: i.a.bool,
      toAscii: i.a.bool,
      render: i.a.func
    }, e.a = o;
  }, function (t, e, s) {
    "use strict";

    var r = s(0),
        n = s.n(r),
        a = s(1),
        i = s.n(a);

    var o = function o(t) {
      switch (!0) {
        case /^uint/.test(t):
          return "number";

        case /^string/.test(t) || /^bytes/.test(t):
          return "text";

        case /^bool/.test(t):
          return "checkbox";

        default:
          return "text";
      }
    };

    var c = /*#__PURE__*/function (_r$Component3) {
      _inherits(c, _r$Component3);

      var _super7 = _createSuper(c);

      function c(t) {
        var _this8;

        _classCallCheck(this, c);

        _this8 = _super7.call(this, t), _this8.handleInputChange = _this8.handleInputChange.bind(_assertThisInitialized(_this8)), _this8.handleSubmit = _this8.handleSubmit.bind(_assertThisInitialized(_this8)), _this8.contracts = t.drizzle.contracts, _this8.utils = t.drizzle.web3.utils;
        var e = _this8.contracts[_this8.props.contract].abi;
        _this8.inputs = [];

        for (var s = {}, r = 0; r < e.length; r++) {
          if (e[r].name === _this8.props.method) {
            _this8.inputs = e[r].inputs;

            for (var n = 0; n < _this8.inputs.length; n++) {
              s[_this8.inputs[n].name] = "";
            }

            break;
          }
        }

        _this8.state = s;
        return _this8;
      }

      _createClass(c, [{
        key: "handleSubmit",
        value: function handleSubmit(t) {
          var _this9 = this,
              _this$contracts$this$3,
              _this$contracts$this$4;

          t.preventDefault();
          var e = this.inputs.map(function (t) {
            return "bytes32" === t.type ? _this9.utils.toHex(_this9.state[t.name]) : _this9.state[t.name];
          });
          return this.props.sendArgs ? (_this$contracts$this$3 = this.contracts[this.props.contract].methods[this.props.method]).cacheSend.apply(_this$contracts$this$3, _toConsumableArray(e).concat([this.props.sendArgs])) : (_this$contracts$this$4 = this.contracts[this.props.contract].methods[this.props.method]).cacheSend.apply(_this$contracts$this$4, _toConsumableArray(e));
        }
      }, {
        key: "handleInputChange",
        value: function handleInputChange(t) {
          var e = "checkbox" === t.target.type ? t.target.checked : t.target.value;
          this.setState(_defineProperty({}, t.target.name, e));
        }
      }, {
        key: "render",
        value: function render() {
          var _this10 = this;

          return this.props.render ? this.props.render({
            inputs: this.inputs,
            inputTypes: this.inputs.map(function (t) {
              return o(t.type);
            }),
            state: this.state,
            handleInputChange: this.handleInputChange,
            handleSubmit: this.handleSubmit
          }) : n.a.createElement("form", {
            className: "pure-form pure-form-stacked",
            onSubmit: this.handleSubmit
          }, this.inputs.map(function (t, e) {
            var s = o(t.type),
                r = _this10.props.labels ? _this10.props.labels[e] : t.name;
            return n.a.createElement("input", {
              key: t.name,
              type: s,
              name: t.name,
              value: _this10.state[t.name],
              placeholder: r,
              onChange: _this10.handleInputChange
            });
          }), n.a.createElement("button", {
            key: "submit",
            className: "pure-button",
            type: "button",
            onClick: this.handleSubmit
          }, "Submit"));
        }
      }]);

      return c;
    }(r.Component);

    c.propTypes = {
      drizzle: i.a.object.isRequired,
      contract: i.a.string.isRequired,
      method: i.a.string.isRequired,
      sendArgs: i.a.object,
      labels: i.a.arrayOf(i.a.string),
      render: i.a.func
    }, e.a = c;
  }]);
});